import { app, Component } from 'apprun';
import { __, lang } from './Txlat';
import { getAgentLink } from './utility';
import { paginateAssets, sortAgentsOrAgencies, PageSize } from './utility';
import PageControl from './pageControl';
import InqueryTitle from './agent-inquiry-title';
export default class AgentListing extends Component {
  view = (state) => {
    return (<AgentListingTemplate it={this} agents={state.agents} pageAgents={state.pageAgents} page={state.page} />);
  };
  update = {
    'sort-order-changed': (state, e) => {
      const sortOrderId = e.currentTarget.id;

      let sortBy;
      switch (sortOrderId) {
        case 'bs-select-1-1': { sortBy = 'a_name'; break; }
        case 'bs-select-1-2': { sortBy = 'd_name'; break; }
        default: { sortBy = ''; break; }
      }

      state.page = 1;
      state.agents = sortAgentsOrAgencies(state.agents, sortBy);
      state.pageAgents = paginateAssets(state.agents, state.page);
      state.agentSortOrder = e.target.innerText;

      return state;
    },

    '/setComponentState': async (state, { agencyAgents }) => {
      state.agents = agencyAgents;
      state.sortby = '';

      state.agents = sortAgentsOrAgencies(state.agents, state.sortby);
      state.pageAgents = paginateAssets(state.agents, 1);
      state.page = 1;
      state.agentSortOrder = 'Default Order';
      return state;
    },

    'gotoPage': (state, targetPageNumber) => {
      state.page = targetPageNumber;
      state.pageAgents = paginateAssets(state.agents, targetPageNumber);

      return state;
    },
  };
}

function AgentListingTemplate({ it, agents, pageAgents, page }) {
  if (!agents) { return; }
  return (
    <div>
      {agents && agents.length > 0 ? <div><div class="listing-tools-wrap">
        <div class="d-flex align-items-center">
          <div class="page-title flex-grow-1">
            <PageControl page={page} total={agents.length} size={PageSize} type='agent' />
          </div>

          <div class="sort-by">
            <div class="d-flex align-items-center">
              <div class="sort-by-title">
                {__('Sort by')}:
              </div>
              <div id="divDropDown" class="dropdown bootstrap-select form-control">
                <button type="button" tabindex="-1" class="btn dropdown-toggle btn-light bs-placeholder" data-toggle="dropdown" role="combobox" aria-owns="bs-select-1" aria-haspopup="listbox" aria-expanded="false" data-id="sort_properties" title="Default Order">
                  <div class="filter-option">
                    <div class="filter-option-inner">
                      <div class="filter-option-inner-inner">{__(it.state.agentSortOrder)}</div>
                    </div>
                  </div>
                </button>

                <ul class="dropdown-menu" role="presentation" style="margin-top: 0px; margin-bottom: 0px; text-transform:none">
                  <li><a onclick={e => it.run('sort-order-changed', e)} role="option" class="dropdown-item" id="bs-select-1-0" tabindex="0" aria-setsize="6" aria-posinset="1" aria-selected="true"><span class="text">{__('Default Order')}</span></a></li>
                  <li><a onclick={e => it.run('sort-order-changed', e)} role="option" class="dropdown-item" id="bs-select-1-1" tabindex="0"><span class="text">{__('Name A-Z')}</span></a></li>
                  <li><a onclick={e => it.run('sort-order-changed', e)} role="option" class="dropdown-item" id="bs-select-1-2" tabindex="0"><span class="text">{__('Name Z-A')}</span></a></li>

                </ul>
              </div>
            </div>
          </div>
        </div>
      </div>{pageAgents.map(p => <div>{AgentTemplate(p)}</div>)}
      </div> : ''}
    </div>
  );
}

function AgentTemplate(agent) {
  return (
    <div class="listing-view list-view card-deck">

      <div class="item-listing-wrap hz-item-gallery-js card" data-images="" style='padding: 3px 5px;margin-bottom: 10px;'>
        <div class="item-wrap item-wrap-v1 item-wrap-no-frame h-100">
          <div class="d-flex align-items-center h-100">
            <div class="item-header">
              <div class="listing-image-wrap">
                <div class="listing-thumb">
                  <a target={'agent' + agent.id} href={getAgentLink(agent, lang.get())} class="listing-featured-thumb"><img width="180" src={agent.photo_path} class="img-fluid wp-post-image" alt="" loading="lazy" style="width:180; !important; object-fit: cover;object-position:0 0; max-width: 100%; cursor: pointer; " /></a>
                </div>
              </div>
              <div class="preview_loader"></div>
            </div>
            <div class="item-body flex-grow-1">
              <ul class="item-amenities item-amenities-with-icons">
                <li>
                  <h2 class="item-title">
                    <a target={'agent' + agent.id} href={getAgentLink(agent, lang.get())}><b>{agent.name}</b></a>
                  </h2>
                </li>
              </ul>

              {(agent.title && agent.title !== '' || agent.title_FR && agent.title_FR !== '') ?
                <ul class="item-amenities item-amenities-with-icons">
                  <li>{lang.get() === 'en' ? agent.title : agent.title_FR}</li>
                </ul>
                : ''}

              {(agent.agencyName && agent.agencyName !== '') ?
                <ul class="item-amenities item-amenities-with-icons">
                  <li>{agent.agencyName}</li>
                </ul>
                : ''}

              <ul class="item-amenities item-amenities-with-icons">
                <li>{agent.address}</li>
              </ul>

              <ul class="item-amenities item-amenities-with-icons">
                <li>{agent.city.toUpperCase()}&nbsp;{agent.province.toUpperCase()}&nbsp;{agent.postal_code.toUpperCase()}</li>
              </ul>

              <ul class="item-amenities item-amenities-with-icons">
                {(agent.phone && agent.phone !== '') ? <li><strong>{__('Agency')}</strong> <a href={'tel:' + agent.phone}><span class="agent-phone ">{agent.phone}</span></a></li> : ''}
              </ul>
              <ul class="item-amenities item-amenities-with-icons">
                {(agent.mobile && agent.mobile !== '') ? <li><strong>{__('Mobile')}</strong> <a href={'tel:' + agent.mobile}><span class="agent-phone ">{agent.mobile}</span></a></li> : ''}
              </ul>

              <ul class="item-amenities item-amenities-with-icons">
                <div class="d-flex justify-content-between">
                  <a class="btn btn-search btn-secondary " href='' style='line-height:30px; color:white;' $onclick={['/openInqueryModal', { inqueryTitle: <InqueryTitle agent1={agent} agent2='' />, email: agent.email, inquiryType: 'AgentInquiry', agent1: agent, form_type: 'AgentProfile', formName: 'agentListing' }]}>
                    {__('Contact agent')}
                  </a>
                  <a class="btn btn-secondary" style='line-height:30px; color:white;' target={'agent' + agent.id} href={getAgentLink(agent, lang.get())}>{__('Details')}</a>
                </div>
              </ul>
            </div>
          </div>
        </div>
      </div >

    </div >

  );

}
